(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCarousel(sectionEl) {
    var viewport = sectionEl.querySelector('[data-mm-viewport]');
    var belt = sectionEl.querySelector('[data-mm-belt]');
    if (!viewport || !belt) return;

    var cards = belt.querySelectorAll('[data-mm-card]');
    if (cards.length < 2) return;

    // Clone cards for infinite loop
    cards.forEach(function(card) {
      belt.appendChild(card.cloneNode(true));
    });

    var pos = 0;
    var speed = 0.4;
    var paused = false;
    var dragging = false;
    var dragStartX = 0;
    var dragStartPos = 0;
    var raf;

    function getHalfWidth() {
      return belt.scrollWidth / 2;
    }

    function tick() {
      if (!paused && !dragging) {
        pos += speed;
        if (pos >= getHalfWidth()) pos = 0;
        belt.style.transform = 'translate3d(-' + pos + 'px, 0, 0)';
      }
      raf = requestAnimationFrame(tick);
    }

    tick();

    // Pause on hover
    viewport.addEventListener('mouseenter', function() { paused = true; });
    viewport.addEventListener('mouseleave', function() { paused = false; });

    // Mouse drag
    viewport.addEventListener('mousedown', function(e) {
      dragging = true;
      dragStartX = e.clientX;
      dragStartPos = pos;
      e.preventDefault();
    });

    window.addEventListener('mouseup', function() { dragging = false; });

    window.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      var delta = dragStartX - e.clientX;
      pos = dragStartPos + delta;
      var half = getHalfWidth();
      if (pos < 0) pos += half;
      if (pos >= half) pos -= half;
      belt.style.transform = 'translate3d(-' + pos + 'px, 0, 0)';
    });

    // Touch drag
    viewport.addEventListener('touchstart', function(e) {
      dragging = true;
      dragStartX = e.touches[0].clientX;
      dragStartPos = pos;
    }, { passive: true });

    viewport.addEventListener('touchend', function() { dragging = false; });

    viewport.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      var delta = dragStartX - e.touches[0].clientX;
      pos = dragStartPos + delta;
      var half = getHalfWidth();
      if (pos < 0) pos += half;
      if (pos >= half) pos -= half;
      belt.style.transform = 'translate3d(-' + pos + 'px, 0, 0)';
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.mm-carousel-section').forEach(initCarousel);
  });

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function(e) {
    var sec = e.target.querySelector('.mm-carousel-section');
    if (sec) initCarousel(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multivideo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVshow(section) {
    var viewport = section.querySelector('[data-vshow-viewport]');
    if (!viewport) return;

    var dragStartX = 0;
    var dragStartScroll = 0;
    var isDragging = false;
    var hasDragged = false;
    var DRAG_THRESHOLD = 5;

    viewport.addEventListener('mousedown', function (e) {
      isDragging = true;
      hasDragged = false;
      dragStartX = e.clientX;
      dragStartScroll = viewport.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      isDragging = false;
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var delta = dragStartX - e.clientX;
      if (Math.abs(delta) > DRAG_THRESHOLD) {
        hasDragged = true;
        viewport.scrollLeft = dragStartScroll + delta;
      }
    });

    viewport.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);

    viewport.addEventListener('touchstart', function (e) {
      dragStartX = e.touches[0].clientX;
      dragStartScroll = viewport.scrollLeft;
      hasDragged = false;
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      var delta = dragStartX - e.touches[0].clientX;
      if (Math.abs(delta) > DRAG_THRESHOLD) hasDragged = true;
      viewport.scrollLeft = dragStartScroll + delta;
    }, { passive: true });

    section.querySelectorAll('.mm-vshow-video').forEach(function (v) {
      v.play().catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('.mm-vshow-section').forEach(initVshow);
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('.mm-vshow-section');
    if (sec) initVshow(sec);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
